
    import './styles.scoped.css';
    export default {
  "background": "awsui_background_hyvsj_199dj_93",
  "scrolling-background": "awsui_scrolling-background_hyvsj_199dj_96",
  "sticky-background": "awsui_sticky-background_hyvsj_199dj_102",
  "has-sticky-notifications": "awsui_has-sticky-notifications_hyvsj_199dj_110",
  "breadcrumbs": "awsui_breadcrumbs_hyvsj_199dj_123",
  "has-sticky-background": "awsui_has-sticky-background_hyvsj_199dj_133",
  "drawers-container": "awsui_drawers-container_hyvsj_199dj_145",
  "has-open-drawer": "awsui_has-open-drawer_hyvsj_199dj_157",
  "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_199dj_191",
  "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_hyvsj_199dj_196",
  "has-multiple-triggers": "awsui_has-multiple-triggers_hyvsj_199dj_214",
  "drawers-trigger-content": "awsui_drawers-trigger-content_hyvsj_199dj_246",
  "drawers-trigger": "awsui_drawers-trigger_hyvsj_199dj_246",
  "drawer": "awsui_drawer_hyvsj_199dj_145",
  "drawer-close-button": "awsui_drawer-close-button_hyvsj_199dj_295",
  "drawer-content": "awsui_drawer-content_hyvsj_199dj_300",
  "drawer-slider": "awsui_drawer-slider_hyvsj_199dj_305",
  "is-drawer-open": "awsui_is-drawer-open_hyvsj_199dj_312",
  "content": "awsui_content_hyvsj_199dj_337",
  "layout": "awsui_layout_hyvsj_199dj_358",
  "has-max-content-width": "awsui_has-max-content-width_hyvsj_199dj_441",
  "content-type-dashboard": "awsui_content-type-dashboard_hyvsj_199dj_456",
  "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_199dj_473",
  "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_199dj_505",
  "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_199dj_508",
  "content-first-child-notifications": "awsui_content-first-child-notifications_hyvsj_199dj_518",
  "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_199dj_521",
  "content-first-child-header": "awsui_content-first-child-header_hyvsj_199dj_524",
  "has-header": "awsui_has-header_hyvsj_199dj_524",
  "content-first-child-main": "awsui_content-first-child-main_hyvsj_199dj_545",
  "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_199dj_545",
  "has-split-panel": "awsui_has-split-panel_hyvsj_199dj_588",
  "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_199dj_588",
  "block-body-scroll": "awsui_block-body-scroll_hyvsj_199dj_604",
  "unfocusable": "awsui_unfocusable_hyvsj_199dj_609",
  "container": "awsui_container_hyvsj_199dj_619",
  "is-navigation-open": "awsui_is-navigation-open_hyvsj_199dj_644",
  "is-tools-open": "awsui_is-tools-open_hyvsj_199dj_647",
  "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_199dj_647",
  "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_199dj_647",
  "mobile-toolbar": "awsui_mobile-toolbar_hyvsj_199dj_656",
  "mobile-toolbar-nav": "awsui_mobile-toolbar-nav_hyvsj_199dj_672",
  "mobile-toolbar-breadcrumbs": "awsui_mobile-toolbar-breadcrumbs_hyvsj_199dj_676",
  "mobile-toolbar-tools": "awsui_mobile-toolbar-tools_hyvsj_199dj_680",
  "navigation-container": "awsui_navigation-container_hyvsj_199dj_689",
  "show-navigation": "awsui_show-navigation_hyvsj_199dj_733",
  "animating": "awsui_animating_hyvsj_199dj_755",
  "showButtons": "awsui_showButtons_hyvsj_199dj_1",
  "navigation": "awsui_navigation_hyvsj_199dj_689",
  "openNavigation": "awsui_openNavigation_hyvsj_199dj_1",
  "animated-content": "awsui_animated-content_hyvsj_199dj_816",
  "hide-navigation": "awsui_hide-navigation_hyvsj_199dj_825",
  "notifications": "awsui_notifications_hyvsj_199dj_835",
  "sticky-notifications": "awsui_sticky-notifications_hyvsj_199dj_841",
  "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_199dj_858",
  "position-bottom": "awsui_position-bottom_hyvsj_199dj_904",
  "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_199dj_1",
  "split-panel-side": "awsui_split-panel-side_hyvsj_199dj_933",
  "position-side": "awsui_position-side_hyvsj_199dj_961",
  "openSplitPanelSide": "awsui_openSplitPanelSide_hyvsj_199dj_1",
  "tools-container": "awsui_tools-container_hyvsj_199dj_998",
  "tools": "awsui_tools_hyvsj_199dj_998",
  "openTools": "awsui_openTools_hyvsj_199dj_1",
  "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_199dj_1092",
  "hide-tools": "awsui_hide-tools_hyvsj_199dj_1102",
  "show-tools": "awsui_show-tools_hyvsj_199dj_1114",
  "has-tools-form": "awsui_has-tools-form_hyvsj_199dj_1092",
  "trigger": "awsui_trigger_hyvsj_199dj_1181",
  "selected": "awsui_selected_hyvsj_199dj_1220"
};
  